export const commonValidations = (isEn) => ({
  phone: {
    required: isEn ? 'Please enter the phone number.' : '연락처를 입력해주세요.',
    pattern: {
      value: /^[0-9]{10,11}$/,
      message: isEn
        ? 'Please enter a valid phone number (10-11 digits).'
        : '올바른 휴대폰 번호를 입력해주세요. (10-11자리)',
    },
  },
  email: {
    required: isEn ? 'Please enter the email.' : '이메일을 입력해주세요.',
    pattern: {
      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
      message: isEn ? 'Please enter a valid email address.' : '올바른 이메일 주소를 입력해주세요.',
    },
  },
});
